export const ERROR_URL = "/error";
export const PROFILE_URL = "/profile";